var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"debug-tile",class:{ bottom: _vm.bottom, top: _vm.top, left: _vm.left, right: _vm.right },style:({ color: _vm.color, borderColor: _vm.color })},[_vm._v(" "+_vm._s(_vm.data)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }